<template>
	<div class="l-container works">
		<div class="recently-project-wrap">
			<h1 class="page-tit">Visual Marketing</h1>
			<!-- Thumbnail View : s -->
			<div class="view-area">
				<div class="is-active">
					<div class="select-box-wrap" :class="{ 'align-r': !viewType }">
						<div class="select-box tab">
							<div class="swiper-container tab-swiper">
								<ul class="swiper-wrapper">
									<li
										class="swiper-slide"
										:class="{ 'is-active': status == 'all' }"
									>
										<a href="javascript:;" @click="sortingList('all')">All</a>
										<!-- <router-link to="/visual-marketing">All</router-link> -->
									</li>
									<li
										class="swiper-slide"
										:class="{ 'is-active': status == 'proposal' }"
										v-show="viewType"
									>
										<!-- <router-link to="/visual-marketing?category=proposal"
											>Proposal</router-link
										> -->
										<a href="javascript:;" @click="sortingList('proposal')"
											>Proposal</a
										>
									</li>
									<li
										class="swiper-slide"
										:class="{ 'is-active': status == 'presentation' }"
										v-show="viewType"
									>
										<!-- <router-link to="/visual-marketing?category=presentation"
											>Presentation</router-link
										> -->
										<a href="javascript:;" @click="sortingList('presentation')"
											>Presentation</a
										>
									</li>
								</ul>
							</div>
						</div>
						<div class="select-type">
							<button
								@click="selectViewType('thumbnail')"
								:class="{ 'is-active': viewType }"
							>
								<span class="type-thumb">썸네일타입</span>
							</button>
							<button
								@click="selectViewType('list')"
								:class="{ 'is-active': !viewType }"
							>
								<span class="type-list">리스트</span>
							</button>
						</div>
					</div>
					<div v-if="viewType">
						<div class="recently-project" v-if="ptSize">
							<transition-group tag="ul" name="pt-list">
								<li
									v-for="(pt, i) in ptStore"
									:data-index="i"
									:key="pt.index"
									:data-category="pt.category"
									v-show="pt.show"
									class="pt-list"
									@mouseover="listAnimationEnter"
									@mouseleave="listAnimationLeave"
								>
									<router-link
										v-bind:to="`/visual-marketing/${pt.ptUrl}`"
										class="user"
									>
										<img :src="pt.thumbImg" :alt="pt.thumbImgAlt" />
										<p :title="pt.category" class="desc">
											<strong class="tit" v-html="pt.thumbTitle"></strong>
										</p>
									</router-link>
								</li>
							</transition-group>
						</div>
						<div class="message" v-else>해당하는 프로젝트가 없습니다.</div>
					</div>
					<ul class="presentation-table" v-else>
						<li v-for="(thumbCont, i) in thumbStore" :key="i">
							<strong>{{ thumbCont.title }}</strong>
							<div>{{ thumbCont.desc }}</div>
						</li>
					</ul>
				</div>
				<!-- Thumbnail View : e -->
			</div>
		</div>
		<br />
		<router-view></router-view>
	</div>
</template>

<script>
import { store } from "../data/store.js";
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
export default {
	metaInfo: {
		title: "Visual Marketing",
		meta: [
			{
				vmid: "description",
				name: "description",
				content:
					"제오젠은 효율적인 제안서와 Presentation을 위한 디자인 요소를 가미한 마케팅을 지원합니다.",
			},
		],
	},
	data() {
		return {
			store,
			thumbStore: [],
			viewType: true,
			ptSize: true,
			ptStore: [],
			status: "all",
		};
	},
	methods: {
		listAnimationEnter(e) {
			var $this = $(e.currentTarget);
			if (!$this.hasClass("is-animating")) {
				$this.addClass("is-animating");
				var direction, x, y;
				var $desc = $this.find(".desc");
				var w = $this.width();
				var h = $this.height();
				(x = (e.pageX - $this.offset().left - w / 2) * (w > h ? h / w : 1)),
					(y = (e.pageY - $this.offset().top - h / 2) * (h > w ? w / h : 1)),
					(direction =
						Math.round((Math.atan2(y, x) * (180 / Math.PI) + 180) / 90 + 3) %
						4);

				if (direction == 0) {
					$desc.css({ top: -h, left: 0 });
				} else if (direction == 1) {
					$desc.css({ top: 0, left: w });
				} else if (direction == 2) {
					$desc.css({ top: h, left: 0 });
				} else {
					$desc.css({ top: 0, left: -w });
				}
				$this.find(".desc").stop().animate({ top: 0, left: 0 }, 240);
			}
		},
		listAnimationLeave(e) {
			var $this = $(e.currentTarget);
			var option = {};
			var direction, x, y;
			var w = $this.width();
			var h = $this.height();
			(x = (e.pageX - $this.offset().left - w / 2) * (w > h ? h / w : 1)),
				(y = (e.pageY - $this.offset().top - h / 2) * (h > w ? w / h : 1)),
				(direction =
					Math.round((Math.atan2(y, x) * (180 / Math.PI) + 180) / 90 + 3) % 4);

			if (direction == 0) {
				option = { top: -h, left: 0 };
			} else if (direction == 1) {
				option = { top: 0, left: w };
			} else if (direction == 2) {
				option = { top: h, left: 0 };
			} else {
				option = { top: 0, left: -w };
			}
			$this
				.find(".desc")
				.stop()
				.animate(option, 240, function () {
					$this.removeClass("is-animating");
					$(this).css({ top: 0, left: -w });
				});
		},
		//sortingList(category, event) {
		sortingList(category) {
			if (category == undefined) category = "all";

			category = category.toLowerCase();

			if (category == "all" || category == undefined) {
				this.ptStore.forEach(function (v) {
					v.show = true;
				});
			} else {
				this.ptStore.forEach(function (v) {
					v.show = v.category != category ? false : true;
				});
			}
			//현재 노출 카테고리
			this.status = category;
			if (category != "all") {
				this.$router
					.push(`/visual-marketing?category=${category}`)
					.catch(() => {});
			} else {
				this.$router.push("/visual-marketing").catch(() => {});
			}

			//자료가 없을때
			let showNum = this.ptStore.filter((v) => v.show == true).length;
			this.ptSize = showNum == 0 ? false : true;
		},
		selectViewType(type) {
			if (type != "thumbnail") {
				this.viewType = false;
				this.sortingList("all");
			} else {
				this.viewType = true;
			}
		},
	},
	computed: {},
	mounted() {
		this.sortingList(this.$route.query.category);

		// mobile tab menu swiper control
		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".tab-swiper", {
					slidesPerView: "auto",
					spaceBetween: 20,
					grabCursor: true,
					loop: false,
					slideToClickedSlide: true,
				});
			}
		};

		winW = $window.outerWidth();
		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
				}
			}
		});
	},
	watch: {
		$route(to, from) {
			this.sortingList(this.$route.query.category);
		},
	},
	created() {
		this.ptStore = this.store.bsd.slice().reverse();
		this.ptStore.forEach(function (v) {
			v.show = true;
		});
		this.thumbStore = this.store.bsdThumbs;
	},
};
</script>

<style scoped>
.select-box-wrap {
	display: flex;
	justify-content: space-between;
}
.select-box-wrap.align-r {
	justify-content: flex-end;
}
.select-box-wrap.align-r .swiper-slide:first-child {
	padding-bottom: 4px;
	border-bottom: 1px solid #ff4911;
}
.select-box-wrap.align-r .swiper-slide:first-child:before {
	content: "";
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background-color: transparent;
}
.presentation-table {
	display: block;
	padding: 30px 15px;
	border-top: 1px solid #bcbcbc;
	background-color: #fff;
}
.presentation-table li {
	min-height: 150px;
	padding-top: 27px;
	padding-bottom: 28px;
	color: #222;
	border-bottom: 1px solid #bcbcbc;
	line-height: 1.5;
}
.presentation-table li > strong {
	display: block;
	margin-bottom: 14px;
	font-size: 2.2rem;
	font-weight: bold;
}
.presentation-table li > div {
	font-size: 1.6rem;
}
.select-type button + button {
	margin-left: 28px;
}
.select-type button span {
	overflow: hidden;
	display: inline-block;
	width: 32px;
	height: 32px;
	background: url(/static/img/sorting.png) no-repeat;
	background-size: 65px;
	text-indent: 100%;
	white-space: nowrap;
}
.select-type .type-thumb {
	background-position: 0 0;
}
.select-type .is-active .type-thumb {
	background-position: 0 100%;
}
.select-type .type-list {
	background-position: 100% 0;
}
.select-type .is-active .type-list {
	background-position: 100% 100%;
}
.select-type {
	display: flex;
	justify-content: center;
	width: 100%;
}
.select-box-wrap {
	align-items: center;
	margin-bottom: 25px;
}
@media screen and (min-width: 713px) {
	.select-type {
		display: inline-flex;
		width: 92px;
	}
	.select-box-wrap {
		margin-bottom: 35px;
	}
	.presentation-table {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		padding: 30px;
		border-top: none;
	}
	.presentation-table li {
		padding-top: 24px;
		padding-bottom: 26px;
	}

	@media screen and (max-width: 1279px) {
		.presentation-table li > div {
			font-size: 1.8rem;
		}
		.presentation-table li:nth-child(1),
		.presentation-table li:nth-child(2) {
			border-top: 1px solid #bcbcbc;
		}
		.presentation-table > li {
			flex: 0 0 calc(50% - 30px);
		}
		.presentation-table > li:nth-child(2n + 2) {
			margin-left: 60px;
		}
	}
	@media screen and (min-width: 1280px) {
		.works .select-box-wrap .tab li.is-active {
			padding-bottom: 7px;
			border-bottom: 2px solid #ff4911;
		}
		.select-box-wrap.align-r .swiper-slide:first-child {
			font-weight: 800;
		}
		.presentation-table {
			padding: 40px;
		}
		.presentation-table > li {
			flex: 0 0 calc(33% - 54px);
			min-height: 170px;
			padding-top: 33px;
			padding-bottom: 36px;
		}
		.presentation-table li:nth-child(1),
		.presentation-table li:nth-child(2),
		.presentation-table li:nth-child(3) {
			border-top: 1px solid #bcbcbc;
		}
		.presentation-table > li:not(:nth-child(3n + 1)) {
			margin-left: 80px;
		}

		.presentation-table li > strong {
			margin-bottom: 6px;
			font-size: 3rem;
		}
		.presentation-table li > div {
			font-size: 1.8rem;
		}
	}
}

.pt-list {
	overflow: hidden;
}
.pt-list > a {
	display: block;
	transition: opacity 0.6s, transform 0.6s;
}

.pt-list-enter > a,
.pt-list-leave-to > a {
	opacity: 0;
	transform: translateY(60px);
}
.pt-list-enter-to > a {
	opacity: 1;
	transform: translateY(0);
}
.pt-list-leave-active > a {
	transition: opacity 0.6s 0.6s, transform 0.6s 0.6s;
}
</style>


// WEBPACK FOOTER //
// src/components/XgBSD.vue